module.exports = __webpack_public_path__ + "static/media/become.eeff396f.png";